import {
    Divider,
    DividerProps,
    InternalStandardProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledDivider = styled(Divider)(({ theme }) => ({
    borderColor: theme.palette.grey[300],
}));

export interface AppDividerProps extends InternalStandardProps<DividerProps> {}

export const AppDivider = (props: AppDividerProps) => {
    const { variant = "fullWidth", ...rest } = props;

    return <StyledDivider {...rest} variant={variant} />;
};
